import React from "react";
import { Table } from "reactstrap";

const FurnitureTab = ({ assets = [] }) => {
    if (assets.length === 0) {
        return <p className="text-center text-muted py-4">No furniture recorded.</p>;
    }

    return (
        <Table responsive hover bordered className="table-sm">
            <thead style={{ backgroundColor: "#0147C8", color: "white" }}>
            <tr>
                <th style={{ width: "50px" }}>#</th>
                <th>Barcode / Serial</th>
                <th>Asset Name</th>
                <th>Qty</th>
                <th>Institution & Location</th>
                <th>Acquisition</th>
                <th>Condition</th>
            </tr>
            </thead>
            <tbody>
            {assets.map((a) => {
                const condition = a.observed_condition_name || a.observed_condition || "N/A";

                // Added: Concatenating physical location fields from your schema
                const locationDetails = [
                    a.building_name,
                    a.floor,
                    a.room_name_or_number
                ].filter(Boolean).join(", ") || "-";

                return (
                    <tr key={a.id}>
                        <td className="fw-bold text-muted">{a.serialNumber || "-"}</td>
                        {/* Added: serial_number */}
                        <td>
                            <div className="fw-bold">{a.barcode || "-"}</div>
                            <small className="text-muted">SN: {a.serial_number || "N/A"}</small>
                        </td>
                        <td>
                            <strong>{a.name}</strong>
                            <div className="small text-muted">{a.description || ""}</div>
                        </td>
                        {/* Added: quantity */}
                        <td>{a.quantity || 1}</td>
                        {/* Added: institution_name + concatenated location */}
                        <td>
                            <div className="fw-medium">{a.institution_name || "-"}</div>
                            <small className="text-muted">{locationDetails}</small>
                        </td>
                        {/* Added: acquisition_date */}
                        <td>{a.acquisition_date || "-"}</td>
                        <td>
                            {condition}
                        </td>

                    </tr>
                );
            })}
            </tbody>
        </Table>
    );
};

export default FurnitureTab;
